const Footer = () => {
  return (
    <footer className="p-4 has-background-info-15 has-text-info-85 has-text-centered is-italic">
      by <a
          className="has-text-warning"
          href="https://vlrnsnk.com/"
          target="_blank"
          rel="noopener noreferrer"
         >
          vlrnsnk
         </a>
    </footer>
  );
};

export { Footer };
